import { render } from "./ArticleRowItem.vue?vue&type=template&id=466340ba"
import script from "./ArticleRowItem.vue?vue&type=script&lang=js"
export * from "./ArticleRowItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__